import { Navigate } from 'react-router-dom'
import {
  RESERVE_WELCOME_PACK_PATH,
  RESERVE_WELCOME_PACK_DEFAULT_TOPIC_ID,
} from '../constants/reserveWelcomePack'

/** Base welcome-pack URL opens the handbook at the first topic. */
const ReserveWelcomePackPage = () => (
  <Navigate to={`${RESERVE_WELCOME_PACK_PATH}/${RESERVE_WELCOME_PACK_DEFAULT_TOPIC_ID}`} replace />
)

export default ReserveWelcomePackPage
